import React from 'react';
import { Checkbox, Label, Input, Grid, Segment } from 'semantic-ui-react';

// Could eventually add a drop down to convert to translate between common units (e.g. days to years)

class OutputCheckbox extends React.Component {

  constructor(props) {
    super(props);

    const preVals = this.props.data[this.props.id];
    const toState = preVals === undefined ? undefined : preVals[this.props.name];

    this.state = {values : toState};
    this.onChange = this.onChange.bind(this);
    // If empty, push a default set of values
    if (this.state.values === undefined) {
      let init = { name : this.props.name,
                   id : this.props.id,
                   value : {'FILE_NAME' : this.props.simname + "_" + this.props.name,
                            suffix : this.props.suffix}};
      this.props.onChange({},init);
    }
  }

  onChange(e, d) {
    let update = this.props.data[this.props.id][this.props.name];
    let newval = d.value;
    if (newval === '' & d.name !== 'FILE_NAME') {
      delete update[d.name];
    } else { 
      //if (d.type === 'float') {newval = parseFloat(newval)};
      update[d.name] = newval;
    }

    // Set outgoing name
    d.name = this.props.name;
    
    // Update
    d.value = update;
    d.id = this.props.id;
    this.props.onChange(e,d);
  }

  getDefault(obj,name) {
    return obj[name] === undefined ? "" : obj[name];
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // if sim was changed, larger update needed
    if (nextProps.data[nextProps.id] === undefined) {
      let init = { name : nextProps.name,
                    id : nextProps.id,
                    value : {'FILE_NAME' : '',
                            suffix : nextProps.suffix}};
      nextProps.onChange({},init);
    }
    if (nextProps.data[nextProps.id][nextProps.name] !== prevState.values){
        return({ values : nextProps.data[nextProps.id][nextProps.name] });
    } else {
        return null;
    }
  }

  render() {
    const {label, named, suffix, convert, max, min, dt, id, data, disabled} = this.props;
    const curr = data[this.props.id][this.props.name];
    const {checked} = this.props;
    const columns = [convert, min, max, dt].filter(x => x).length;

    return(
      <div className='modalElement'>
        <Checkbox label={label} onChange={this.props.onCheck} id={id} checked={checked} disabled={disabled} />
        {checked && !disabled && <Segment><Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              {named !== undefined && <Input labelPosition='right' name='FILE_NAME' 
                                                        onChange={this.onChange}
                                                        fluid
                                                        value={this.getDefault(curr, 'FILE_NAME')}>
                                            <Label basic>Output File Name: </Label><input />
                                            <Label>{suffix}</Label></Input>}
            </Grid.Column>
          </Grid.Row>

          {columns > 0 && <Grid.Row columns={columns}>
            {convert !== undefined && <Grid.Column>
              <Input label={{ basic: true, content:'Time Conversion'}}
                      name='TIME_CONVERSION' fluid
                      type='float' onChange={this.onChange}
                      value={this.getDefault(curr, 'TIME_CONVERSION')}
                      className='inputInt' />
            </Grid.Column>}

            {min !== undefined && <Grid.Column>
              <Input label={{ basic: true, content:'Min Time'}}
                      name='MIN_TIME' type='float' fluid
                      onChange={this.onChange}
                      value={this.getDefault(curr, 'MIN_TIME')}
                      className='inputInt' />
            </Grid.Column> }
            
            {max !== undefined && <Grid.Column>
              <Input label={{ basic: true, content:'Max Time'}}
                      name='MAX_TIME' type='float' fluid
                      onChange={this.onChange}
                      value={this.getDefault(curr, 'MAX_TIME')}
                      className='inputInt' />
            </Grid.Column>}
            
            {dt !== undefined && <Grid.Column>
              <Input label={{ basic: true, content:'Output Interval'}}
                      name='TIME_DT' type='float' fluid
                      onChange={this.onChange}
                      value={this.getDefault(curr, 'TIME_DT')}
                      className='inputInt' />
            </Grid.Column> }
          
          </Grid.Row>}
        </Grid></Segment> }
      </div>
    )
  }
}

export default OutputCheckbox;